import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useActionDispatcher } from '../../../hooks';
import { selectOrder } from '../../../store/modules/orders/selectors';
import {
  getOrderRequest,
  resetCurrentOrder,
  saveVideoEditOrderRequest,
} from '../../../store/modules/orders/actions';
import ProjectOrderForm from './ProjectOrderForm';
import { selectProject } from '../../../store/modules/projects/selectors';

const ProjectOrderPage = () => {
  const order = useSelector(selectOrder);
  const { data: project } = useSelector(selectProject);
  const saveOrder = useActionDispatcher(saveVideoEditOrderRequest);
  const { order_id: orderId } = useParams<{ order_id: string }>();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrderRequest(parseInt(orderId, 10)));
  }, [orderId, dispatch]);

  useEffect(() => () => {
    dispatch(resetCurrentOrder());
  }, [dispatch]);

  return (
    <>
      {project && order.data && <ProjectOrderForm record={order} onSubmit={saveOrder} />}
    </>
  );
};

export default ProjectOrderPage;
